<p-fileUpload mode="basic" [auto]="true" [chooseLabel]="label" name="file" url="/api/v1/file" (onUpload)="onUpload($event)" [multiple]="false" [accept]="accept"
  [maxFileSize]="10000000">
</p-fileUpload>